import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "../../routes";
import { toggleLoader } from "store/actions";
const CommonBookingAddress = ({
  step,
  startDateTime,
  endDateTime,
  pickupAddress,
  returnAddress,
  reservationData,
  formik = "",
  vehicalDetailData,
  startAddressLine1,
  startAddressLine2,
  returnAddressLine1,
  returnAddressLine2,
  days,
}) => {
  const addressInfo = useSelector((state) => state?.common?.addressInfo);
  const dispatch = useDispatch();
  // Find the index of the second last comma
  const lastCommaIndex = addressInfo?.company_address?.lastIndexOf(",");
  const secondLastCommaIndex = addressInfo?.company_address?.lastIndexOf(
    ",",
    lastCommaIndex - 1
  );

  // Separate into two lines
  const AddressLine1 =
    addressInfo?.company_address?.substring(0, secondLastCommaIndex) + ",";
  const AddressLine2 = addressInfo?.company_address
    ?.substring(secondLastCommaIndex + 1)
    .trim();

  return (
    <div className="booking-address-wrapper position-relative">
      {/* <hr /> */}
      {reservationData && reservationData?.admin_booking !== 1 && (
        <Link href={`/vehiclebooking/${reservationData.id}`}>
          <a className="edit-booking book-edit">
            <span className="icon icon-edit" onClick={() => {dispatch(toggleLoader("button_loader", false))}}></span>
          </a>
        </Link>
      )}
      <div
        className={`start date-address ${
          !startDateTime && !endDateTime ? "line-set" : ""
        } ${step == 1 && formik?.values?.is_pickup_selected ? "active" : ""}`}
      >
        {startDateTime && <span>{startDateTime}</span>}
        <p className="ln-1">
          {pickupAddress ? startAddressLine1 : AddressLine1}
        </p>

        <p>{pickupAddress ? startAddressLine2 : AddressLine2}</p>
      </div>
      <div
        className={`end date-address ${
          step == 1 && !formik?.values?.is_pickup_selected ? "active" : ""
        }`}
      >
        {endDateTime && <span>{endDateTime}</span>}
        <p className="ln-1">
          {returnAddress
            ? returnAddressLine1
            : pickupAddress
            ? startAddressLine1
            : AddressLine1}
        </p>

        <p>
          {returnAddress
            ? returnAddressLine2
            : pickupAddress
            ? startAddressLine2
            : AddressLine2}
        </p>
      </div>
      <p className="miles-text">
        <span class="icon-roads-new icon"></span>
        <span className="texts">
          {days > 0
            ? vehicalDetailData?.milesday * days
            : vehicalDetailData?.milesday}
           free miles total
          <span> | </span> ${vehicalDetailData?.extramile}/extra mile
        </span>
      </p>
    </div>
  );
};

export default CommonBookingAddress;
